import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";
import SummitFeaturesSection from "../../components/SummitFeaturesSection/SummitFeaturesSection";
import SummitObjectiveServiceSection from "../../components/ServiceSection/SummitObjectiveServiceSection";
import SummitImg from "../../images/about/img-4.webp";

const SummitObjectivePage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Financial Freedom with Financial Control | JSA Online </title>
        <meta
          name="description"
          content="Achieve financial freedom with financial control through JSA Online. Learn practical strategies to manage money, improve cash flow, and build long-term wealth with expert financial guidance."
        />
        <meta
          name="keywords"
          content="Financial Freedom with Financial Control, JSA Online"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle
        pageTitle={"Summit Objectives"}
        pagesub={"Summit Objectives"}
      />

      {/* About The Summit Section */}
      <section
        className="section-padding"
        style={{ paddingTop: "60px", paddingBottom: "60px" }}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* Left Column - Image */}
            <div className="col-xl-6 col-12">
              <div className="summit-left-content">
                <div className="image">
                  <img src={SummitImg} alt="The Cash Flow Summit 2026" />
                </div>
              </div>
            </div>

            {/* Right Column - Content */}
            <div className="col-lg-6 col-md-12">
              <div className="summit-content" style={{ paddingLeft: "30px" }}>
                {/* About Button */}
                <button
                  style={{
                    backgroundColor: "#007bff",
                    color: "white",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "5px",
                    fontSize: "14px",
                    marginBottom: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="fa fa-info-circle"></i>
                  Cash Flow Summit 2026
                </button>

                {/* Main Heading */}
                <h2
                  style={{
                    fontSize: "32px",
                    fontWeight: "bold",
                    color: "#333",
                    marginBottom: "20px",
                    lineHeight: "1.2",
                  }}
                >
                  Summit Objectives & Features – Transform Your Business &
                  Financial Future
                </h2>

                {/* Description */}
                <p
                  style={{
                    fontSize: "16px",
                    color: "#666",
                    lineHeight: "1.6",
                    marginBottom: "30px",
                  }}
                >
                  Welcome to a once-in-a-lifetime opportunity designed to
                  redefine the way you think about money, business, and freedom.
                  The Cash Flow Summit isn't just an event—it's a movement.
                  Imagine mastering proven systems, tapping into AI-powered
                  finance, pitching live to investors, and connecting with a
                  global community of entrepreneurs. That's exactly what you'll
                  experience here.
                </p>

                {/* Main Heading */}
                <h2
                  style={{
                    fontSize: "32px",
                    fontWeight: "bold",
                    color: "#333",
                    marginBottom: "20px",
                    lineHeight: "1.2",
                  }}
                >
                  Why This Summit Matters
                </h2>

                {/* Description */}
                <p
                  style={{
                    fontSize: "16px",
                    color: "#666",
                    lineHeight: "1.6",
                    marginBottom: "30px",
                  }}
                >
                  Every entrepreneur dreams of sustainable business growth and
                  financial independence—but few truly crack the code. At this
                  summit, we’re pulling back the curtain on strategies that have
                  helped thousands build predictable profits, global networks,
                  and lifelong wealth. Whether you’re a startup hustler or a
                  seasoned business owner, this event will catapult you years
                  ahead in your financial journey.
                </p>

              </div>
            </div>
          </div>
        </div>
      </section>
      <SummitObjectiveServiceSection hclass={"services-section"} />
      <SummitFeaturesSection hclass={"features-section"} />
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};

export default SummitObjectivePage;
